import { z } from "zod";

export enum EAppointmentType {
  TECHNICAL_MAINTENANCE = "technicalMaintenance",
  INSTALLATION = "installation",
  COMPLEX_INSTALLATION = "complexInstallation",
  UNINSTALL = "uninstall",
  ADMINISTRATIVE = "administrative",
  INSTALLATION_VX = "installationVx",
  QUALITY_CONTROL = "qualityControl",
  COMPLIANCE_CONTROL = "complianceControl",
  UPMARKET = "upmarket",
  INSTALLATION_FINALIZATION = "installationFinalization",
  PAC_INSTALLATION = "pacInstallation",
  PAC_REINTERVENTION = "pacReintervention",
  PAC_MAINTENANCE = "pacMaintenance",
  PAC_UPMARKET = "pacUpmarket",
  PAC_FINALIZATION = "pacFinalization",
  PAC_UNINSTALL = "pacUninstall",
}

export const appointmentTypeSchema = z.nativeEnum(EAppointmentType);

export const appointmentTypeDtoSchema = z.object({
  name: appointmentTypeSchema,
  durationMinutes: z.number(),
});

export type TAppointmentTypeDto = z.infer<typeof appointmentTypeDtoSchema>;
